export const ApiEndpoints = {
  auth: '/auth',
  login: '/auth/login',
  register: '/auth/register',
  logout: '/auth/logout',
  refreshToken: '/auth/refresh',
  verifyEmail: '/auth/verify-email',
  resendOtp: '/auth/resend-otp',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',

  users: '/users',
  userById: (id: string) => `/users/${id}`,
  userFollowers: (id: string) => `/users/${id}/followers`,
  userFollowing: (id: string) => `/users/${id}/following`,
  userFollow: (id: string) => `/users/${id}/follow`,
  mutedUsers: '/muted-users',

  posts: '/posts',
  upload: '/upload',
  postById: (id: string) => `/posts/${id}`,
  postLike: (id: string) => `/posts/${id}/like`,
  postComments: (id: string) => `/posts/${id}/comments`,
  comments: '/comments',
  commentById: (id: string) => `/comments/${id}`,
  followedPosts: '/followed-posts',

  marketplace: '/marketplace',
  marketplaceProducts: '/products',
  productById: (id: string) => `/products/${id}`,
  productReviews: (id: string) => `/products/${id}/reviews`,
  reviews: '/reviews',
  reviewById: (id: string) => `/reviews/${id}`,
  sales: '/sales',
  saleById: (id: string) => `/sales/${id}`,
  myPurchases: '/sales/my/bought',
  mySales: '/sales/my/sold',

  jobs: '/jobs',
  jobById: (id: string) => `/jobs/${id}`,
  jobView: (id: string) => `/jobs/${id}/view`,
  jobsApplications: '/jobs/applications',
  myJobApplications: '/jobs/applications/my',
  jobApplicationsList: (jobId: string) => `/jobs/${jobId}/applications`,

  inquiries: '/inquiries',
  myInquiries: '/inquiries/my',
  productInquiries: (productId: string) => `/products/${productId}/inquiries`,

  services: '/services',
  serviceBookings: '/services/bookings',
  serviceBookingById: (id: string) => `/services/bookings/${id}`,
  serviceBookingStatus: (id: string) => `/services/bookings/${id}/status`,

  riding: '/riding',
  ridingSignup: '/riding/signup',
  ridingSignups: '/riding/signups',

  travel: '/travel',
  travelTrips: '/trips',
  publicTrips: '/trips/public',
  travelTripById: (id: string) => `/trips/${id}`,

  chat: '/chat',
  chatMessages: '/chat/messages',
  chatMessageById: (id: string) => `/chat/messages/${id}`,
  directMessages: '/messages',
  conversation: (userId: string) => `/messages/conversation/${userId}`,
  directMessageRead: (id: string) => `/messages/${id}/read`,
  directMessageUnreadCount: '/messages/unread-count',

  notifications: '/notifications',
  notificationRead: (id: string) => `/notifications/${id}/read`,
  notificationsReadAll: '/notifications/read-all',
  notificationsUnreadCount: '/notifications/unread-count',

  streakActivity: '/streaks/activity',
  transactions: '/transactions',
  transactionById: (id: string) => `/transactions/${id}`,
  transactionRelease: (id: string) => `/transactions/${id}/release`,
  transactionDispute: (id: string) => `/transactions/${id}/dispute`,

  challenges: '/challenges',
  challengeById: (id: string) => `/challenges/${id}`,
  challengeJoin: (id: string) => `/challenges/${id}/join`,
  challengeLeave: (id: string) => `/challenges/${id}/leave`,
  badges: '/badges',

  aiChat: '/ai/chat',
  aiChats: '/ai/chats',
  aiChatById: (id: string) => `/ai/chats/${id}`,
  aiMessages: (id: string) => `/ai/chat/${id}/messages`,
  aiUsage: '/ai/usage',
  aiBots: '/ai/bots',
  aiBotById: (id: string) => `/ai/bots/${id}`,
  aiBotToggle: (id: string) => `/ai/bots/${id}/toggle`,

  pushSubscribe: '/push/subscribe',
  pushUnsubscribe: '/push/unsubscribe',
};
